import {extend} from 'flarum/extend';
import app from 'flarum/app';
import Button from 'flarum/components/Button';
import DiscussionControls from 'flarum/utils/DiscussionControls';
import UserControls from 'flarum/utils/UserControls';
import ActorAuditModal from './components/ActorAuditModal';
import DiscussionAuditModal from './components/DiscussionAuditModal';
import UserAuditModal from './components/UserAuditModal';
import AuditLog from '../common/models/AuditLog';

app.initializers.add('kilowhat-audit', () => {
    app.store.models['kilowhat-audit'] = AuditLog;

    extend(DiscussionControls, 'moderationControls', function (items, discussion) {
        if (!app.forum.attribute('canAudit')) {
            return;
        }

        items.add('kilowhat-audit-user', Button.component({
            icon: 'fas fa-book',
            onclick() {
                app.modal.show(DiscussionAuditModal, {
                    discussion,
                });
            },
        }, app.translator.trans('kilowhat-audit.forum.link.discussion-audit')));
    });

    extend(UserControls, 'moderationControls', function (items, user) {
        if (!app.forum.attribute('canAudit')) {
            return;
        }

        items.add('kilowhat-audit-user', Button.component({
            icon: 'fas fa-book',
            onclick() {
                app.modal.show(UserAuditModal, {
                    user,
                });
            },
        }, app.translator.trans('kilowhat-audit.forum.link.user-audit')));

        items.add('kilowhat-audit-actor', Button.component({
            icon: 'fas fa-book',
            onclick() {
                app.modal.show(ActorAuditModal, {
                    user,
                });
            },
        }, app.translator.trans('kilowhat-audit.forum.link.actor-audit')));
    });
});
